import type { FaireProductEntity } from "../../entity_types/product";

export const p_fdwecku67j: FaireProductEntity = {
  token: "p_fdwecku67j",
  type: "product",
  name: "Natural Fluorite Mermaid 7cm Crystal Healing Energy",
  brandToken: "b_edj9u7j4sq",
  brandName: "KayleeNYC",
  imageUrl:
    "https://cdn.faire.com/fastly/6eae9a20a97f590b039ab6e416a0857ff5d7688a59d8eaf1222a7c7eb2466a91.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/adec028d54478a46fa2dfab4c7c45736ddfcbef8df623c5d5de44d25c82b603c.jpeg",
    "https://cdn.faire.com/fastly/7bf45b411520075152b0326d1da38e291fddc30758ccffa2b3997fddedf9b753.jpeg",
    "https://cdn.faire.com/fastly/f1d5e42b8539da186c9516010393bfd6840b5a487a6f75ea51bd01b8e63628a7.jpeg",
    "https://cdn.faire.com/fastly/c59fe24b18a802545f661704ed5d8e5938319a0c1ebbf880ef5a9e9c3de9aecb.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "Add a magical and eye-catching touch to your collection with these beautifully carved Natural Fluorite mermaid figurines. Fluorite is admired for its natural bands of purple, green, and translucent tones, giving each fairy a unique and enchanting appearance.\n\nProduct Details:\n\t•\tStone: Natural Fluorite\n\t•\tCarving: mermaid \n\t•\tSize: Approximately 7 cm\n\t•\tQuantity: 6 Pieces per Lot\n\t•\tCondition: New\nMinimum order 6 pieces \n\nThese crystal mermaid carvings are perfect for crystal collectors, gift shops, metaphysical stores, or anyone who appreciates detailed gemstone art.\n\nPlease Note:\nNatural Fluorite may contain natural color variations, inclusions, and cracks. Each carving is unique due to the natural characteristics of the stone.\n\nLocal pickup is available in Brooklyn, New York. \n\nStones, stone, crystal, crystals, crystals bulk, crystals wholesale, spiritual, spiritual items, meditation, metaphysical wholesale.",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:07.096Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
